import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { LogActionsAPI } from '../../../../API/log_action';

import { unoTheme } from '../../../../assets/styles/unoTheme'

import moment from 'moment';
import { useDispatch } from 'react-redux';
import allActions from '../../../../actions';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  inactive: {
    color: '#999',
  },
  note: {
    color: '#999',
    fontStyle: 'italic',
  },
}));

const ROLE_LABELS = {
  ROLE_MANAGER: 'Gestor',
  ROLE_SUBMANAGER: 'Subgestor',
  ROLE_VIEWER: 'Visualizador',
};

const formatDay = (day) => day ? moment(day, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-';

/**
 * Ranking de assiduidade no uso do sistema (equipe interna excluída no backend)
 * @param {string} startDate YYYY-MM-DD
 * @param {string} endDate YYYY-MM-DD
 * @param {'users'|'clients'} view
 */
export default function UsageRanking({ startDate, endDate, view }) {

  const classes = useStyles();
  const dispatch = useDispatch();

  // Linhas e visão juntas: atualizadas em dois setState após o await, renderizariam um meio-termo
  const [ranking, setRanking] = useState({ view, rows: [] });
  const { rows, view: rowsView } = ranking;

  async function doGetUsageRanking() {
    dispatch(allActions.innerLoadActions.setInnerLoad({
      show: true,
      loadMessage: 'Carregando assiduidade...'
    }));

    const response = await LogActionsAPI.getUsageRanking(startDate, endDate, view);

    if (response.success && response.body) {
      setRanking({ view, rows: response.body.rows });
      if (response.body.rows.length > 0) {
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
      } else {
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Não existem acessos no período' }));
      }
    } else {
      console.error("RESPONSE ERROR: ", response.body);
      setRanking({ view, rows: [] });
      dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Erro ao carregar a assiduidade' }));
    }
  }

  useEffect(() => {
    if (startDate && endDate) {
      doGetUsageRanking();
    }
  }, [startDate, endDate, view]);

  const isUsersView = rowsView === 'users';

  return (
    <div className={classes.root}>
      <div class={'defaultScrollWithHeaderContent'}>
        <MyTable
          stickyHeader
          nofixed={true}
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell align="left">#</TableCell>
              {
                isUsersView ?
                  <>
                    <TableCell align="left">Usuário</TableCell>
                    <TableCell align="left">Perfil</TableCell>
                    <TableCell align="left">Cliente</TableCell>
                  </>
                  :
                  <>
                    <TableCell align="left">Cliente</TableCell>
                    <TableCell align="right">Usuários ativos</TableCell>
                    <TableCell align="right">Usuários com acesso</TableCell>
                  </>
              }
              <TableCell align="right">Dias com acesso</TableCell>
              <TableCell align="right">Logins</TableCell>
              <TableCell align="right">Último acesso</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={'usage-ranking-' + rowsView + '-' + index}>
                <TableCell align="left">{index + 1}</TableCell>
                {
                  isUsersView ?
                    <>
                      <TableCell align="left" className={row.active ? null : classes.inactive}>
                        {row.username.toUpperCase()}{row.active ? '' : ' (inativo)'}
                      </TableCell>
                      <TableCell align="left">{ROLE_LABELS[row.role] || row.role || '-'}</TableCell>
                      <TableCell align="left">{row.client_label || '-'}</TableCell>
                    </>
                    :
                    <>
                      <TableCell align="left">{row.client_label}</TableCell>
                      <TableCell align="right">{Number(row.total_users)}</TableCell>
                      <TableCell align="right">{Number(row.active_users)}</TableCell>
                    </>
                }
                <TableCell align="right" style={{ color: unoTheme.mainColor }}>{Number(row.access_days)}</TableCell>
                <TableCell align="right">{Number(row.logins)}</TableCell>
                <TableCell align="right">{formatDay(row.last_access)}</TableCell>
              </TableRow>
            ))}
            {
              rows.length > 0 ?
                <TableRow>
                  <TableCell colSpan={7} align="left" className={classes.note}>
                    Dias com acesso: dias com login ou com uso do sistema. O uso diário só passou a ser registrado
                    a partir desta versão; antes disso, apenas os logins explícitos contam, e o login não expira
                    (quem permanece logado aparece menos). Equipe interna (super admins, admins e consultores) não entra no ranking.
                  </TableCell>
                </TableRow> : null
            }
          </TableBody>
        </MyTable>
      </div>
    </div>
  );
}
